<template>
	<div class="xxzy-main">
		<div style="width: 600px; margin: 0 auto;">
			<img src="../../../static/building.png" style="height: 100%; width: 100%;" alt="">
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page,
		},
		data() {
			return {

			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = ''
		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	.xxzy-main {
		width: 74%;
		margin: 30px 13% 40px;
	}
</style>



// WEBPACK FOOTER //
// src/views/second_classroom/zxkt.vue